module.exports = __webpack_public_path__ + "media/images/lb/764-8c544cc5c726b50223a90eb2958ceabc.svg";